import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, IconButton, Icon, Message } from 'rsuite'
import '../../../pages/proposal/styles.less'
import GranteeProperty from './GranteeProperty'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { Grid, Row, Col } from 'rsuite'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import * as granteePropertyApi from '../../../redux/actions/granteeProperty'
import { startLoading, doneLoading } from '../../../utils/loading'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'

export default function GranteePropertyView(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const dispatch = useDispatch()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.formSchema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [displayData, setDisplayData] = useState({})

  useEffect(() => {
    let resGrantRadio
    if (formSchema.forms.property.partOne.grantRadio['value']) {
      if (formSchema.forms.property.partOne.grantRadio['value'] === '0') {
        resGrantRadio =
          '-' + formSchema.forms.property.partOne.grantRadio['txtResultDisplay'][0]['text']
      } else {
        resGrantRadio =
          '-' + formSchema.forms.property.partOne.grantRadio['txtResultDisplay'][1]['text']
      }
    } else {
      resGrantRadio = formSchema.forms.property.messageIsNull
    }

    let areaRadio
    if (formSchema.forms.property.partOne.areaRadio['value']) {
      if (formSchema.forms.property.partOne.areaRadio['value'] === '0') {
        areaRadio = '-' + formSchema.forms.property.partOne.areaRadio['txtResultDisplay'][0]['text']
      } else {
        areaRadio = '-' + formSchema.forms.property.partOne.areaRadio['txtResultDisplay'][1]['text']
      }
    } else {
      areaRadio = formSchema.forms.property.messageIsNull
    }

    let experienceRadio
    if (formSchema.forms.property.partTwo.experienceRadio['value']) {
      if (formSchema.forms.property.partTwo.experienceRadio['value'] === '0') {
        experienceRadio =
          '-' + formSchema.forms.property.partTwo.experienceRadio['txtResultDisplay'][0]['text']
      } else {
        experienceRadio =
          '-' +
          formSchema.forms.property.partTwo.experienceRadio['txtResultDisplay'][1]['text'] +
          ' ' +
          formSchema.forms.property.partTwo.inputExperience['value']
      }
    } else {
      experienceRadio = formSchema.forms.property.messageIsNull
    }

    let jobAbandonerRadio
    if (formSchema.forms.property.partThree.jobAbandonerRadio.value) {
      jobAbandonerRadio = formSchema.forms.property.partThree.jobAbandonerRadio.value
    }

    let capitalCorruptionRadio
    if (formSchema.forms.property.partThree.capitalCorruptionRadio.value) {
      capitalCorruptionRadio = formSchema.forms.property.partThree.capitalCorruptionRadio.value
    }

    let wrongConditionRadio
    if (formSchema.forms.property.partThree.wrongConditionRadio.value) {
      wrongConditionRadio = formSchema.forms.property.partThree.wrongConditionRadio.value
    }

    let objectiveRadio
    if (formSchema.forms.property.partThree.objectiveRadio.value) {
      objectiveRadio = formSchema.forms.property.partThree.objectiveRadio.value
    }

    let objBusinessRadio
    if (formSchema.forms.property.partThree.objBusinessRadio.value) {
      objBusinessRadio = formSchema.forms.property.partThree.objBusinessRadio.value
    }

    setDisplayData({
      resGrantRadio,
      areaRadio,
      experienceRadio,
      jobAbandonerRadio,
      capitalCorruptionRadio,
      wrongConditionRadio,
      objectiveRadio,
      objBusinessRadio,
    })
  }, [formSchema])

  const projectVersionId = projectId
  const userId = sessionStorage.getItem('proposal_id')

  const handleCallService = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      let response

      const data = {
        id: request.forms.property.id ? request.forms.property.id : '',
        projectVersionId: id,
        userId: userId,
        grantRadio: request.forms.property.partOne.grantRadio['value'],
        inputProject: request.forms.property.partOne.inputProject['value'],
        inputAmountProject: request.forms.property.partOne.inputAmountProject.value,
        areaRadio: request.forms.property.partOne.areaRadio['value'],
        inputArea: request.forms.property.partOne.inputArea['value'],
        inputAmountArea: request.forms.property.partOne.inputAmountArea.value,
        experienceRadio: request.forms.property.partTwo.experienceRadio['value'],
        inputExperience: request.forms.property.partTwo.inputExperience['value'],
        jobAbandonerRadio: request.forms.property.partThree.jobAbandonerRadio['value'],
        capitalCorruptionRadio: request.forms.property.partThree.capitalCorruptionRadio['value'],
        wrongConditionRadio: request.forms.property.partThree.wrongConditionRadio['value'],
        objectiveRadio: request.forms.property.partThree.objectiveRadio['value'],
        objBusinessRadio: request.forms.property.partThree.objBusinessRadio['value'],
      }

      if (request.forms.property.id) {
        response = await granteePropertyApi.updateGranteeProperty(
          id,
          data,
          request.forms.property.id
        )
      } else {
        response = await granteePropertyApi.saveGranteeProperty(id, data)
      }

      if (response) {
        setFormSchema({ forms: { property: response } })
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }

      onChangeIsEdit(false)
    } catch (error) {
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    formSchema.forms.property.partOne.grantRadio['value'] = data.grant
    if (data.grant === '1') {
      formSchema.forms.property.partOne.inputProject['value'] = data.projectName
      formSchema.forms.property.partOne.inputAmountProject['value'] = data.amountProject
    } else {
      formSchema.forms.property.partOne.inputProject['value'] = ''
      formSchema.forms.property.partOne.inputAmountProject['value'] = null
    }

    formSchema.forms.property.partOne.areaRadio['value'] = data.area
    if (data.area === '1') {
      formSchema.forms.property.partOne.inputArea['value'] = data.projectarea
      formSchema.forms.property.partOne.inputAmountArea['value'] = data.amountArea
    } else {
      formSchema.forms.property.partOne.inputArea['value'] = ''
      formSchema.forms.property.partOne.inputAmountArea['value'] = null
    }

    formSchema.forms.property.partTwo.experienceRadio['value'] = data.experience
    if (data.experience === '1') {
      formSchema.forms.property.partTwo.inputExperience['value'] = data.projectexperience
    } else {
      formSchema.forms.property.partTwo.inputExperience['value'] = ''
    }

    formSchema.forms.property.partThree.jobAbandonerRadio['value'] = data.jobAbandoner
    formSchema.forms.property.partThree.capitalCorruptionRadio['value'] = data.capitalCorruption
    formSchema.forms.property.partThree.wrongConditionRadio['value'] = data.wrongCondition
    formSchema.forms.property.partThree.objectiveRadio['value'] = data.objective
    formSchema.forms.property.partThree.objBusinessRadio['value'] = data.objbusiness

    handleCallService(projectVersionId, formSchema)
  }

  const containerStyles = {
    paddingRight: '30px',
    paddingLeft: '30px',
    paddingTop: '8px',
    paddingBottom: '8px',
  }

  const marginTopStyle = {
    marginTop: '0.5%',
  }

  return (
    <>
      {formSchema && (
        <Panel
          header={formSchema.header}
          bordered
          collapsible
          defaultExpanded
          shaded
          className="proposal-grantee-property-widget"
        >
          <WarningMessage
            style={{ marginTop: -10 }}
            message={formSchema?.forms?.property?.feedbackBySubject}
          />

          {isEdit && showCommandButton ? (
            <GranteeProperty
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          ) : (
            <div className="proposal-grantee-property-no-frame">
              <Panel
                className="proposal-grantee-property-content-panel"
                header={
                  formSchema.forms.property.subjectName ||
                  'ประวัติการได้รับทุนจาก สสส. ในช่วง 3 ปีที่ผ่านมา'
                }
              >
                <Grid>
                  <Row>
                    <Col xs={24}>
                      <b
                        dangerouslySetInnerHTML={{
                          __html:
                            '&#9679;  ' + formSchema.forms.property.partOne.grantRadio['label'],
                        }}
                      ></b>{' '}
                    </Col>
                    <Col xs={24}>
                      <div style={containerStyles}> {displayData.resGrantRadio}</div>
                    </Col>
                  </Row>
                  <Row style={marginTopStyle}>
                    <Col xs={24}>
                      <b
                        dangerouslySetInnerHTML={{
                          __html:
                            '&#9679;  ' + formSchema.forms.property.partOne.areaRadio['label'],
                        }}
                      ></b>
                    </Col>
                    <Col xs={24}>
                      <div style={containerStyles}>{displayData.areaRadio}</div>
                    </Col>
                  </Row>
                </Grid>
                <hr />
              </Panel>

              <Panel
                header={formSchema.forms.property.partTwo.subjectName}
                className="proposal-grantee-property-content-panel"
              >
                <Grid>
                  <Row>
                    <Col xs={24}>
                      <b
                        dangerouslySetInnerHTML={{
                          __html:
                            '&#9679;  ' +
                            formSchema.forms.property.partTwo.experienceRadio['label'],
                        }}
                      ></b>
                    </Col>
                    <Col xs={24}>
                      <div style={containerStyles}>{displayData.experienceRadio}</div>
                    </Col>
                  </Row>
                </Grid>
                <hr />
              </Panel>

              <Panel
                header={formSchema.forms.property.partThree.subjectName}
                className="proposal-grantee-property-content-panel"
              >
                <Grid>
                  <Row>
                    <Col xs={24}>
                      <b
                        dangerouslySetInnerHTML={{
                          __html: formSchema.forms.property.partThree.jobAbandonerRadio['label'],
                        }}
                      ></b>
                    </Col>
                    <Col xs={24}>
                      <div style={containerStyles}>
                        {displayData.jobAbandonerRadio
                          ? '-' +
                            formSchema.forms.property.partThree.jobAbandonerRadio.options[
                              displayData.jobAbandonerRadio
                            ].label
                          : formSchema.forms.property.messageIsNull}
                      </div>
                    </Col>
                  </Row>
                  <Row style={marginTopStyle}>
                    <Col xs={24}>
                      <b
                        dangerouslySetInnerHTML={{
                          __html:
                            formSchema.forms.property.partThree.capitalCorruptionRadio['label'],
                        }}
                      ></b>
                    </Col>
                    <Col xs={24}>
                      <div style={containerStyles}>
                        {displayData.capitalCorruptionRadio
                          ? '-' +
                            formSchema.forms.property.partThree.jobAbandonerRadio.options[
                              displayData.capitalCorruptionRadio
                            ].label
                          : formSchema.forms.property.messageIsNull}
                      </div>
                    </Col>
                  </Row>
                  <Row style={marginTopStyle}>
                    <Col xs={24}>
                      <b
                        dangerouslySetInnerHTML={{
                          __html: formSchema.forms.property.partThree.wrongConditionRadio['label'],
                        }}
                      ></b>
                    </Col>
                    <Col xs={24}>
                      <div style={containerStyles}>
                        {displayData.wrongConditionRadio
                          ? '-' +
                            formSchema.forms.property.partThree.jobAbandonerRadio.options[
                              displayData.wrongConditionRadio
                            ].label
                          : formSchema.forms.property.messageIsNull}
                      </div>
                    </Col>
                  </Row>
                  <Row style={marginTopStyle}>
                    <Col xs={24}>
                      <b
                        dangerouslySetInnerHTML={{
                          __html: formSchema.forms.property.partThree.objectiveRadio['label'],
                        }}
                      ></b>
                    </Col>
                    <Col xs={24}>
                      <div style={containerStyles}>
                        {displayData.objectiveRadio
                          ? '-' +
                            formSchema.forms.property.partThree.jobAbandonerRadio.options[
                              displayData.objectiveRadio
                            ].label
                          : formSchema.forms.property.messageIsNull}
                      </div>
                    </Col>
                  </Row>
                  <Row style={marginTopStyle}>
                    <Col xs={24}>
                      <b
                        dangerouslySetInnerHTML={{
                          __html: formSchema.forms.property.partThree.objBusinessRadio['label'],
                        }}
                      ></b>
                    </Col>
                    <Col xs={24}>
                      <div style={containerStyles}>
                        {displayData.objBusinessRadio
                          ? '-' +
                            formSchema.forms.property.partThree.jobAbandonerRadio.options[
                              displayData.objBusinessRadio
                            ].label
                          : formSchema.forms.property.messageIsNull}
                      </div>
                    </Col>
                  </Row>
                </Grid>
              </Panel>
            </div>
          )}

          {showCommandButton && (
            <>
              <hr />
              {isEdit ? (
                <div>
                  <IconButton
                    appearance="ghost"
                    style={{ marginRight: '10px' }}
                    onClick={handleSubmit(onSubmit)}
                    icon={<Icon className="bt-gost-icon-radius" icon="save" />}
                  >
                    บันทึกการแก้ไข
                  </IconButton>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-cancel"
                    onClick={() => {
                      onChangeIsEdit(!isEdit)
                    }}
                    icon={<Icon className="bt-gost-icon-radius-cancel" icon="close" />}
                  >
                    ยกเลิกการแก้ไข
                  </IconButton>
                </div>
              ) : (
                <IconButton
                  appearance="ghost"
                  className="rs-btn-ghost-edit"
                  onClick={() => {
                    onChangeIsEdit(!isEdit)
                    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                  }}
                  icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
                >
                  แก้ไขชื่อคุณสมบัติพื้นฐานและลักษณะต้องห้ามผู้นำเสนอโครงการ
                </IconButton>
              )}
            </>
          )}
        </Panel>
      )}
    </>
  )
}
